import { UsergroupDeleteOutlined } from "@ant-design/icons";
import { getColorFromName } from "../../../utils";
import { t } from "../../../languages";

const StudentList = ({ lang, students }) => {
    const numStudents = students ? students.length : 0;

    return <div className="students-list">
        <p><UsergroupDeleteOutlined /> {numStudents} {t(lang, 'participants')}</p>

        {numStudents ? <ul className="student-items">
            {students.map((student, idx) => {
                return (
                    <li key={`${student.uid}-${idx}`} className="student-item">
                        <div
                            className="student-avatar"
                            style={{ backgroundColor: getColorFromName(idx) }}
                        >
                            {student.avatar ? <img src={`./static/avatar/${student.avatar}.jpg`} alt="" /> : student.name.charAt(0).toUpperCase()}
                        </div>
                        <div className="student-info">
                            <strong>{student.name}</strong>
                        </div>
                    </li>
                );
            })}
        </ul> : null}
    </div>;
}

export default StudentList;